import React from "react";

const defaultRights = {
  readOnlyFull: true
};

export const RightsContext = React.createContext(defaultRights);
